// extracted by css-extract-rspack-plugin
export default {"paymentRequestDialogV2Container":"paymentRequestDialogV2Container-Ei9OcP"};